import React, {Component} from 'react';
import {connect} from 'react-redux';
import {RootState, selectors} from '../store';
import {
  IonButtons,
  IonButton,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonInput,
  IonRow,
  IonCol,
  IonIcon,
  IonCheckbox
} from '@ionic/react';
import './Login.css';
import {RouteComponentProps} from "react-router";
import {checkmark} from 'ionicons/icons';
import {StaticEvent} from "../_/StaticEvent";
import {ApiService} from "../_/ApiService";
import {Static} from "../_/Static";
import _ from "../_";
import {BaseComponent} from "./_/BaseComponent";

type Props = RouteComponentProps<{}> & ReturnType<typeof mapStateToProps>
type State = {
  showPopover: boolean,
  showPopoverEvent: null | MouseEvent,
  password?: any,
  passwordagain?: any,
}

class Emailvertify extends BaseComponent<Props, State> {
  static RoutePathname = /^\/emailverify/gi;

  constructor(props: Props) {
    super(props);

    // @ts-ignore
    // @ts-ignore
    // this.state = {
    //   username: null
    // }
    this.state = {
      password: '',
    };
  }

  updateUserName(e: CustomEvent) {
  }

  handleInputChange(e) {
    if (e.target.name == 'password') {
      // @ts-ignore
      this.state.password = e.target.value;
    }
    if (e.target.name == 'passwordagain') {
      // @ts-ignore
      this.state.passwordagain = e.target.value;
    }
    if (this.state.password === this.state.passwordagain) {
      document.getElementById('markCheck').classList.add("checkpass");
    } else {
      document.getElementById('markCheck').classList.remove("checkpass");
    }

    // @ts-ignore
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  setPassword(e: any) {
    e.preventDefault();
    e.stopPropagation();

    const params = new URLSearchParams(window.location.search);

    const scode = params.get("scode");
    const vcode = params.get("vcode");
    const email = params.get("email");

    // @ts-ignore
    const {password, passwordagain} = this.state;

    if (password != passwordagain) {
      alert('新密碼不一致，請修正');
      return;
    }
    // @ts-ignore
    //const {dispatch} = this.props;
    //dispatch(userActions.login(username, password));

    if (email && password && passwordagain) {
      // WAITING SCREEN
      StaticEvent.LoadingEvent.next(true);

      // POST
      let postData = {
        scodeEmail: scode,
        vcodeEmail: vcode,
        email: email,
        newpassword: passwordagain,
      };
      const postUrl = ApiService.urlMapping('~/api/1/_emailconfirmedsetpassword');
      Static.apiService
        .post(postUrl, postData)
        .subscribe(async (res) => {
            // CLOSE WAITING SCREEN
            StaticEvent.LoadingEvent.next(false);

            let data = res.data;
            _.debugManager.log(data);

            let error = data.error || null;
            let result = error == null;

            if (result) { // SUCEESS
              alert('密碼修改成功，請重新登入')

              // @ts-ignore
              this.props.history.push('/login');

              //window.location = '/f1';
              //history.pushState({}, 'page 2', '/f1');
              //await _.sharedStateManager.rootNav.setRoot(askMeIndex, {});
              //await this.viewCtrl.dismiss();
            } else {
              alert(error.message);
              // const controller: any = document.querySelector('ion-toast-controller');
              // let msg = await controller.create({
              //   message: error.message,
              //   duration: 2000,
              //   position: 'top'
              // });
              // await msg.present();
            }
          }, async (err) => {
            // CLOSE WAITING SCREEN
            StaticEvent.LoadingEvent.next(false);
            _.debugManager.warn(err);
            alert('網路連線有問題');
          }
        );
    }


  }


  signUpUser() {
  }

  render() {
    return (
      <>
        <div className="logo">
          <div className="plustitle">帳號驗證成功</div>
          {/* <div className="count">ruby02181208@gamil.com</div> */}
          <div className="main_logo">
            <div className="bx1"></div>
            <div className="bx2"></div>
            <div className="bx3"></div>
            <div className="bx4"></div>
            <div className="bx5"></div>
            <div className="bx6"></div>
            <div className="bx7"></div>
            <div className="bx8"></div>
            <div className="bx9"></div>
            <div className="bx10"></div>
            <div className="bx11"></div>
            <div className="bx12"></div>
            <div className="bx13"></div>
            <div className="bx14"></div>
            <div className="bx15"></div>
            <div className="bx16"></div>
            <div className="bx17"></div>
            <div className="bx18"></div>
            <div className="bx19"></div>
            <div className="bx20"></div>
            <div className="bx21"></div>
            <div className="bx22"></div>
            <div className="bx23"></div>
            <div className="bx24"></div>
            <div className="bx25"></div>
            <div className="bx26"></div>
            <div className="bx27"></div>
            <div className="bx28"></div>
            <div className="bx29"></div>
            <div className="bx30"></div>
            <div className="bx31"></div>
            <div className="bx32"></div>
            <div className="bx33"></div>
            <div className="bx34"></div>
            <div className="bx35"></div>
            <div className="bx36"></div>
            <div className="bx37"></div>
            <div className="bx38"></div>
            <div className="bx39"></div>
            <div className="bx40"></div>
            <div className="bx41"></div>
            <div className="bx42"></div>
            <div className="bx43"></div>
            <div className="bx44"></div>
            <div className="bx45"></div>
            <div className="bx46"></div>
            <div className="bx47"></div>
            <div className="bx48"></div>
            <div className="bx49"></div>
            <div className="bx50"></div>
            <div className="bx51"></div>
            <div className="bx52"></div>
            <div className="bx53"></div>
            <div className="bx54"></div>
            <div className="bx55"></div>
            <div className="bx56"></div>
            <div className="bx57"></div>
            <div className="bx58"></div>
            <div className="bx59"></div>
            <div className="bx60"></div>
            <div className="bx61"></div>
            <div className="bx62"></div>
            <div className="bx63"></div>
            <div className="bx64"></div>
            <div className="bx65"></div>
            <div className="bx66"></div>
            <div className="bx67"></div>
            <div className="bx68"></div>
            <div className="bx69"></div>
            <div className="bx70"></div>
            <div className="bx71"></div>
            <div className="bx72"></div>
            <div className="bx73"></div>
            <div className="bx74"></div>
            <div className="bx75"></div>
            <div className="bx76"></div>
            <div className="bx77"></div>
            <div className="bx78"></div>
            <div className="bx79"></div>
            <div className="bx80"></div>
            <div className="bx81"></div>
            <div className="bx82"></div>
            <div className="bx83"></div>
            <div className="bx84"></div>
            <div className="bx85"></div>
            <div className="bx86"></div>
            <div className="bx87"></div>
            <div className="bx88"></div>
            <div className="bx89"></div>
            <div className="bx90"></div>
            <div className="bx91"></div>
            <div className="bx92"></div>
            <div className="bx93"></div>
            <div className="bx94"></div>
            <div className="bx95"></div>
            <div className="bx96"></div>
            <div className="bx97"></div>
            <div className="bx98"></div>
            <div className="bx99"></div>
            <div className="bx100"></div>
          </div>
        </div>
        <div className="loginform">
          <IonList no-lines>
            <IonItem>
              <IonLabel position="floating">設定密碼</IonLabel>
              <IonInput
                name="password"
                onInput={(e: any) => this.handleInputChange(e)}
                placeholder="請輸入密碼"
                value={this.state.password}
                type="password" required>
              </IonInput>
            </IonItem>
            <IonItem id="markCheck">
              <IonLabel position="floating">確認密碼</IonLabel>
              <IonInput
                name="passwordagain"
                onInput={(e: any) => this.handleInputChange(e)}
                placeholder="請再輸入確認密碼"
                value={this.state.passwordagain}
                type="password" required>
              </IonInput>
            </IonItem>
            {/* <IonItem lines="none">
              <IonCheckbox color="primary" slot="start"/>
              <IonLabel className="ptxt">同意，並詳閱服務條款及隱私權政策</IonLabel>
            </IonItem> */}
          </IonList>

          <IonRow responsive-sm>
            <IonCol>
              <IonButton expand="block" color="primary" type="submit" onClick={(e) => this.setPassword(e)}>
                送出
              </IonButton>
            </IonCol>
          </IonRow>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  isAuthenticated: state.user.isAuthenticated
});

export default connect(
  mapStateToProps
)(Emailvertify);
